import { styled } from 'styled-components';

export const LoginPageContainer = styled.div`


`;